import { Icono } from './Icono';
import './cifras.css';
import type { NombreIcono } from './iconos';

/**
 * Baldosas grandes para elegir una opción con el dedo (4.7: «Efectivo · Datáfono»): icono arriba y nombre debajo, la
 * elegida con borde rojo. Es un grupo de radio para los lectores de pantalla.
 */
export interface Baldosa<V extends string> {
    valor: V;
    texto: string;
    icono: NombreIcono;
}

export function Baldosas<V extends string>({ etiqueta, opciones, valor, onCambio, bloqueadas = false }: { etiqueta: string; opciones: readonly Baldosa<V>[]; valor: V | null; onCambio: (v: V) => void; bloqueadas?: boolean }) {
    return (
        <div className="rv-baldosas" role="radiogroup" aria-label={etiqueta}>
            {opciones.map((o) => (
                <button
                    key={o.valor}
                    type="button"
                    role="radio"
                    aria-checked={valor === o.valor}
                    disabled={bloqueadas}
                    className={`rv-baldosas__b${valor === o.valor ? ' rv-baldosas__b--on' : ''}`}
                    onClick={() => {
                        onCambio(o.valor);
                    }}
                >
                    <Icono nombre={o.icono} />
                    <span>{o.texto}</span>
                </button>
            ))}
        </div>
    );
}
